
import { ref, computed } from 'vue';
import { login as loginApi, logout as logoutApi, getCurrentUser, checkAuth } from '../services/authService';

const isAuthenticated = ref(false);
const currentUser = ref(null);
const isLoading = ref(false);

export const initializeAuth = () => {
  const user = getCurrentUser();
  if (user) {
    currentUser.value = user;
    isAuthenticated.value = true;
  }
};

export const useAuth = () => {
  const login = async (email, password) => {
    isLoading.value = true;
    try {
      const result = await loginApi(email, password);

      if (result.success) {
        currentUser.value = result.data;
        isAuthenticated.value = true;
        return { success: true };
      } else {
        return { success: false, error: result.error };
      }
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'An unexpected error occurred.' };
    } finally {
      isLoading.value = false;
    }
  };

  const logout = async () => {
    isLoading.value = true;
    try {
      const result = await logoutApi();

      currentUser.value = null;
      isAuthenticated.value = false;

      return { success: result.success };
    } catch (error) {
      console.error('Logout error:', error);
      currentUser.value = null;
      isAuthenticated.value = false;
      return { success: false };
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isAuthenticated: computed(() => isAuthenticated.value),
    currentUser: computed(() => currentUser.value),
    isLoading: computed(() => isLoading.value),
    login,
    logout,
  };
};

